const ONE_YEAR = new Date();
ONE_YEAR.setFullYear(ONE_YEAR.getFullYear() + 1);

export const setCookie = (
  cookieName: string,
  value: string,
  domain: string,
  path?: string
) => {
  const cookiesEnabled =
    typeof document !== "undefined" &&
    typeof navigator !== "undefined" &&
    navigator.cookieEnabled;
  console.error(
    "cookies debug",
    typeof navigator,
    typeof navigator !== "undefined",
    typeof document,
    typeof document !== "undefined",
    navigator && navigator.cookieEnabled,
    { cookieName, value, domain, path }
  );

  if (cookiesEnabled) {
    const cookiePath = path ? `Path=${path};` : "";

    document.cookie = `${cookieName}=${value}; ${cookiePath} Domain=${domain}; Expires=${ONE_YEAR.toUTCString()}`;
  }
};
